import { AdicionarCestaObserver } from './adicionarCesta.observer'
import { AdicionarItemCestaObserver as Tagmanager} from 'core/tag-manager/adicionarItemCesta.observer'
import { AdicionarItemCestaObserver as Chaordic} from 'core/chaordic/adicionarItemCesta.observer'
import { CestaService } from '../cesta.service'
import { Observable, Subject } from 'rxjs'

export class AdicionarCestaComponent {
    constructor() {
        this.btnAddToCartElements = document.querySelectorAll(".btn[data-click='addToCart']")
        this.service = new CestaService()
        this.init()
    }

    init() {
        if(this.btnAddToCartElements) {
            Array.prototype.forEach.call(this.btnAddToCartElements, btn => {
                let btnClickStream = Observable.fromEvent(btn, 'click')
                btnClickStream
                    .debounceTime(400)
                    .map(event => (
                        {
                            codigoItem: event.target.getAttribute('data-item'),
                            quantidade: (event.target.getAttribute('data-item-qtde')) ? event.target.getAttribute('data-item-qtde') : 1,
                            codigoOferta: event.target.getAttribute('data-codigo-oferta'),
                        }
                    ))
                    .filter(itemObj => this.validateItemObj(itemObj))
                    .subscribe(itemObj => this.addToCart(itemObj))
            })
        }
    }

    addToCart(itemObj) {
        const modalVendaRestritaAtiva = document.querySelector(".modal-vendarestrita.modal--active");

        if(modalVendaRestritaAtiva) {
            document.querySelector("[data-modal='vendarestrita']").click();
        }

        return this.service
                    .adicionarItemNaCesta(itemObj)
                    .subscribe(this.addToCartResponse(itemObj));
    }

    addToCartResponse(itemAdicionado) {
        let adicionarItemNaCestaSubject = new Subject();
        adicionarItemNaCestaSubject.subscribe(new AdicionarCestaObserver())
        adicionarItemNaCestaSubject.subscribe(new Tagmanager(itemAdicionado))
        adicionarItemNaCestaSubject.subscribe(new Chaordic())

        return {
            next: response => adicionarItemNaCestaSubject.next(response),
            error: error => adicionarItemNaCestaSubject.error(error),
            complete: () => console.log("Complete")
        }
    }

    validateItemObj(itemObj) {
        return itemObj.codigoItem != null
                && itemObj.codigoItem != ""
                && itemObj.quantidade != null
                && itemObj.quantidade != ""
                && !isNaN(itemObj.quantidade)
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/cesta/adicionar/adicionarCesta.component.js